import { Clear, Search as SearchIcon } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const DEBOUNCE_MS = 500;

export default function TemplatesSearchFilter({
  initialValue = "",
  onSearchChange,
}) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = React.useState(initialValue);
  const timeoutRef = useRef(null);

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  //Clears timer on component unmount to prevent onSearchChange calls after the component is gone
  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  function handleChange(e) {
    const val = e.target.value;
    setInputValue(val);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => onSearchChange(val), DEBOUNCE_MS);
  }

  function handleClear() {
    clearTimeout(timeoutRef.current);
    setInputValue("");
    onSearchChange("");
  }

  return (
    <TextField
      sx={{ width: "100%" }}
      size="small"
      placeholder={t("SearchByTitle")}
      value={inputValue}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
        endAdornment: inputValue && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} size="small" title={t("Clear")}>
              <Clear fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
